import React, { useState, Fragment } from 'react';
import { TemplateServiceList } from './TemplateServiceList';
import { AxiosAPI } from '../../../../../../helpers/AxiosAPI';
import { gAPI_CopyServices } from '../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';

function TemplateServiceButton({ propertyId, domains, LoadData, isServiceOrder, locale, languageCode }) {
    const [visible, setVisible] = useState(false);
    const handleSubmit = data => {
        AxiosAPI({
            method: 'post',
            url: `${gAPI_CopyServices}`,
            data,
        })
            .then(
                res => {
                    setVisible(!visible)
                    setTimeout(() => {
                        LoadData(languageCode);
                    }, 1000);
                }
            )
            .catch(err => {
                console.log('err', err);
            });
    };

    return (
        <Fragment>
            <Button
                color="primary"
                size="xs"
                outline
                className="top-right-button mr-1"
                onClick={() => {
                    setVisible(!visible);
                }}
            >
                + Add From Templates
            </Button>


            <TemplateServiceList
                formLabel="Template Service List"
                visible={visible}
                toggle={() => {
                    setVisible(!visible);
                }}
                submit={handleSubmit}
                propertyId={propertyId}
                domainName={domains}
                isServiceOrder={isServiceOrder}
                languageCode={languageCode}
            />
        </Fragment>
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId, domains, locale } = settings;
    return {
        propertyId,
        domains,
        locale
    };
};

export default injectIntl(connect(mapStateToProps, {})(TemplateServiceButton));

TemplateServiceButton.propTypes = {
    propertyId: PropTypes.string.isRequired,
};
